<template>
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg8>
            <p class="table_card__head--title">Plantillas</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12 lg4 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="$router.push({name: 'new_whatsapp_template'})"
              >
                Crear nueva plantilla
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="getTemplates()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="Templates"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props" >
            <td @click="editItem(props.item)" style="cursor: pointer">{{ props.item.name }}</td>
          </template>
        </v-data-table>

        <v-dialog v-model="modal_details" max-width="424px">
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">New Item</v-btn> -->
          <v-card style="border-radius: 10px">
            <v-card-title style="border-bottom: 1px solid #E9E9F0">
              <h5 class="table_card__head--title">
                <v-icon style="font-size: 30px">mark_email_unread</v-icon>
                <span class="ml-2">Detalle de la plantilla</span>
              </h5>
            </v-card-title>
            <v-card-text style="padding: 0">
              <v-container grid-list-md style="color: #5A6B8E">
                <v-layout wrap>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Título</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 600">
                      {{editedItem.name}}
                    </p>
                  </v-flex>
                  <v-flex xs12>
                    <span style="font-size: 12px; color: #5A6B8E">Mensaje</span>
                    <p style="font-size: 14px; margin-bottom: 0; font-weight: 600">
                      {{editedItem.message}}
                    </p>
                  </v-flex>
                  <v-flex xs12 v-if="image_url">
                    <span style="font-size: 12px; color: #5A6B8E">Imagen</span>
   
                    <div
                      class="data_card__import_img"
                      :style="{backgroundImage: 'url('+ image_url+')'}"> 
                    </div>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#5A6B8E" flat @click.native="close()">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        modal_details: false,
        image_url: '',
        Templates: [],
        headers: [
            { text: 'Nombre plantilla', sortable: false, value: 'name' }
        ],
        editedItem: {
          attributes:{
            title:'',
            message: '',
            users: [],
            send_date_time: null
          }
        },
        defaultItem: {
          attributes:{
            title:'',
            message: '',
            users: [],
            send_date_time: null
          }
        },
        editedIndex: -1
      }
    },
    mounted(){
      this.getTemplates();
    },
    methods: {
      getTemplates(){
        try {
          this.$http.get('push_messages_templates/get_templates',{
            headers:{
              "X-Device-ID": this.getDeviceId(),
              "Authorization": 'Bearer ' + this.getUserToken()
            }
          })
          .then(function(response){
            this.Templates = response.body.data
            console.log('this.Templates', this.Templates)
            // cl Templates
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      },
      editItem (item) {
        this.editedIndex = this.Templates.indexOf(item)        
        this.editedItem = Object.assign({}, item)
        this.image_url = this.editedItem.image.url != null || '' ? this.getImageServer() + this.editedItem.image.url : null

        this.modal_details = true
      },
      close () {
        this.modal_details = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/views/whatsapp_templates/Index.vue